import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { getcategorylist } from "../services/categoryService";

const API_BASE = import.meta.env.VITE_API_URL ?? "http://localhost:8000/api";

export default function MobileProductsMenu({ onLinkClick }) {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [openCats, setOpenCats] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!open || fetched) return;
  //   setLoading(true);
  //   fetch(`${API_BASE}/category/list`)
  //     .then((r) => r.json())
  //     .then((res) => {
  //       setCategories(res.data ?? []);
  //       setFetched(true);
  //     })
  //     .catch(() => {})
  //     .finally(() => setLoading(false));
  // }, [open, fetched]);
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await getcategorylist(); 
        console.log(res.data.data);
        
        setCategories(res.data.data ?? []);
        setFetched(true);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  console.log({categories});
  

  const parentCats = categories.filter((c) => !c.parent_id && c.status === "active");
  const getSubcats = (parentId) =>
    categories.filter((c) => c.parent_id === parentId && c.status === "active");

  const toggleCat = (catId) =>
    setOpenCats((prev) => ({ ...prev, [catId]: !prev[catId] }));

  const handleNav = (path) => {
    navigate(path);
    onLinkClick?.();
  };

  return (
    <div className="border-b border-gray-100">
      {/* Products toggle */}
      <div className="flex items-center justify-between py-3.5">
        <button
          onClick={() => handleNav("/products")}
          className="text-sm font-medium text-gray-700 hover:text-[#43a047] transition-colors"
        >
          Products
        </button>
        <button
          onClick={() => setOpen((v) => !v)}
          className="p-1 text-gray-400 hover:text-gray-600"
        >
          <FaChevronDown
            size={11}
            className={`transition-transform duration-200 ${open ? "rotate-180 text-[#43a047]" : ""}`}
          />
        </button>
      </div>

      {open && (
        <div className="pb-3 pl-4 space-y-1 bg-gray-50/50 rounded-sm px-2">
          {loading && (
            <p className="text-xs text-gray-400 py-2">Loading...</p>
          )}
          {!loading && parentCats.map((cat) => {
            const subs = getSubcats(cat.category_id);
            const isCatOpen = openCats[cat.category_id];
            return (
              <div key={cat.category_id}>
                <div className="flex items-center justify-between py-2 border-b border-gray-100/50">
                  <button
                    onClick={() => handleNav(`/products?category=${cat.category_id}`)}
                    className="text-xs text-gray-600 hover:text-[#43a047] transition-colors capitalize font-medium"
                  >
                    {cat.name}
                  </button>
                  {subs.length > 0 && (
                    <button
                      onClick={() => toggleCat(cat.category_id)}
                      className="p-1 text-gray-400"
                    >
                      <FaChevronDown
                        size={9}
                        className={`transition-transform duration-200 ${isCatOpen ? "rotate-180 text-[#43a047]" : ""}`}
                      />
                    </button>
                  )}
                </div>

                {/* Subcategories */}
                {subs.length > 0 && isCatOpen && (
                  <div className="pl-3 py-1 space-y-1">
                    {subs.map((sub) => (
                      <button
                        key={sub.category_id}
                        onClick={() => handleNav(`/products?category=${sub.category_id}`)}
                        className="flex items-center gap-1.5 w-full text-left py-1.5 text-xs text-gray-500 hover:text-[#43a047] transition-colors capitalize"
                      >
                        <span className="w-1 h-1 rounded-full bg-gray-300 flex-shrink-0" />
                        {sub.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          {!loading && (
            <Link
              to="/products"
              onClick={onLinkClick}
              className="block pt-2 text-xs font-medium text-[#43a047]"
            >
              View All →
            </Link>
          )}
        </div>
      )}
    </div>
  );
}